export const getBaseUrlSelector = (state) => state.app.baseUrl;

export const getUserRoleSelector = (state) => {
  return state.user.role === 'MODERATOR' || state.user.role === 'ADMIN'
    ? 'MODERATOR'
    : state.user.role;
};
export const getMessengersListSelector = (state) => state.app.messengers;

export const getPublicLink = (state) => state.object.publicLink;

export const getPriceTypesSelector = (state) => state.object.pricesTypes;

export const getPhotoDoneStatus = (state) => state.app.isPhotoDone;
